<template>
  <div class="flex flex-nowrap items-baseline" :class="{ 'pt-6': showProductsSavingsLabel }">
    <span
      v-if="compareAtPrice && compareAtPrice.amount > 0"
      class="text-gray-light block line-through decoration-blackly mr-2 fluid-lg leading-tight self-baseline font-light!"
      data-test-id="old-price"
    >
      {{
        $n(parseFloat(compareAtPrice.amount), {
          style: 'currency',
          currency: compareAtPrice.currencyCode || currencyCode,
        })
      }}
    </span>

    <span
      v-else-if="priceFrom"
      class="fluid-xs text-gray-light text-center leading-none md:leading-normal mr-1"
      data-test-id="price-range"
    >
      {{ $t('product.from') }}
    </span>

    <div v-if="price" class="relative self-baseline">
      <span
        :class="[
          priceClass ? priceClass : 'fluid-base',
          compareAtPrice && compareAtPrice.amount > 0 ? 'leading-tight' : 'leading-7',
        ]"
        data-test-id="price"
      >
        {{
          $n(parseFloat(price.amount), {
            style: 'currency',
            currency: price.currencyCode || currencyCode,
          })
        }}

        <ProductSavingsLabel
          v-if="showProductsSavingsLabel"
          class="absolute left-1/2 -translate-x-1/2 bottom-full mt-2"
          arrowDirection="down"
        >
          <span v-if="textForSavingsLabel?.length">{{ textForSavingsLabel }}</span>
          <span v-else>
            {{ $t('savingsLabel') }}
            {{
              $n(savings, {
                style: 'currency',
                currency: price.currencyCode || currencyCode,
              })
            }}
          </span>
        </ProductSavingsLabel>
      </span>
    </div>
  </div>
</template>

<script>
import ProductSavingsLabel from '~/components/shop/products/ProductSavingsLabel.vue';
import { useGlobalBannerStore } from '@/stores/global-banner';

export default defineNuxtComponent({
  components: { ProductSavingsLabel },

  setup() {
    const globalBannerStore = useGlobalBannerStore();
    return { globalBannerStore };
  },

  props: {
    price: {
      type: Object,
      default: () => {},
    },
    compareAtPrice: {
      type: Object,
      default: () => {},
    },
    priceRangeMin: {
      type: String,
      default: undefined,
    },
    priceRangeMax: {
      type: String,
      default: undefined,
    },
    priceClass: {
      type: String,
      default: undefined,
    },
    comparePriceClass: {
      type: String,
      default: undefined,
    },
    currencyCode: {
      type: String,
      default: 'EUR',
    },
  },
  computed: {
    textForSavingsLabel() {
      return this.globalBannerStore.textForSavingsLabel;
    },
    showSavingsLabelPLP() {
      return this.globalBannerStore.showSavingsLabelPLP;
    },

    showProductsSavingsLabel() {
      return (
        (this.textForSavingsLabel?.length > 0 && this.compareAtPrice?.amount > 0) ||
        (this.showSavingsLabelPLP && this.savings > 0)
      );
    },

    savings() {
      if (this.price?.amount && this.compareAtPrice?.amount) {
        return parseFloat(this.compareAtPrice.amount) - parseFloat(this.price.amount);
      }
      return 0;
    },

    priceFrom() {
      return this.priceRangeMin !== this.priceRangeMax && this.price.amount === this.priceRangeMin;
    },
  },
});
</script>
